var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertIcon = function SvgAlertIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.906 11.875h1.188v-4.75H8.906zm0 2.374h1.188v-1.187H8.906zm8.434.317L11.054 3.342A1.76 1.76 0 0 0 9.5 2.43c-.654 0-1.235.34-1.555.911L1.66 14.567a1.77 1.77 0 0 0 .018 1.77c.323.552.897.881 1.536.881h12.574c.638 0 1.213-.33 1.536-.88.323-.552.33-1.214.017-1.772",
    clipRule: "evenodd"
  })));
};
export default SvgAlertIcon;